<template>
    <div class="batch-api" v-show="$store.state.batchApiLoading">
        <div class="container">
            <div class="status-icon">
                <i class="el-icon-loading" v-if="status === 'play'"></i>
                <i class="el-icon-video-pause" v-if="status === 'pause'"></i>
            </div>
            <div class="process">{{processing_completed.length}} / {{processing_completed.length + request_queue.length}} </div>
            <div class="message" :class="message_type">{{message}}</div>
            <div class="buttons" v-if="status === 'pause'">
                <el-button type="primary" icon="el-icon-refresh-right" @click="action('重试该请求')">重试该请求</el-button>
                <el-button type="primary" icon="el-icon-video-play" @click="action('跳过该请求')">跳过该请求</el-button>
                <el-button type="danger" icon="el-icon-circle-close" @click="action('结束请求')" v-if="message_type === 'error'">结束请求</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import store from "@/store";
/**
 * 批量请求API组件
 */
export default {
    name: "BatchApi",
    data() {
        return {
            status: "play", // pause

            message: "请求中",
            message_type: "normal", // error

            processing_completed: [], // 处理完成的队列
            request_queue: [], // 请求队列，完成一个请求后，进入处理完成的队列

            processingGenerator: null, // 请求发送器的生成器。

            callback: null // 回调函数
        };
    },
    methods: {
        batchApi(
            request_queue = [
                {
                    api: "", // 请求的api
                    data: "", // 请求的数据
                    callback: null, //单个请求成功的回调
                    errorCallBack: null //单个请求失败的回调
                }
            ],
            callback
        ) {
            this.status = "play";

            this.message = "请求中";
            this.message_type = "normal";

            this.processing_completed = [];
            this.request_queue = request_queue;

            store.commit("batchLoading", true);

            this.callback = callback;

            this.processingGenerator = this.processing();
            this.processingGenerator.next();
        },

        action(select) {
            this.status = "play";

            this.message = "请求中"; // 显示信息
            this.message_type = "normal";

            this.processingGenerator.next(select);
        },

        /**
         * 返回一个生成器
         */
        async *processing() {
            while (this.request_queue.length > 0) {
                const request = this.request_queue[0];

                try {
                    const response = await this.callApi(
                        request.api,
                        request.data
                    );

                    if (typeof request.callback === "function")
                        request.callback(response);

                    this.message = response.msg;

                    this.processing_completed.push(this.request_queue.shift()); // 请求顺利结束，放入处理完成队列
                } catch (error) {
                    if (typeof request.errorCallBack === "function")
                        request.errorCallBack(error);

                    this.status = "pause";

                    this.message = error; // 显示信息
                    this.message_type = "error";

                    const what_to_do_next = yield error; // 交出控制权，暂停请求进程。

                    if (what_to_do_next === "重试该请求") {
                        continue;
                    }

                    if (what_to_do_next === "跳过该请求") {
                        this.processing_completed.push(
                            this.request_queue.shift()
                        );
                        continue;
                    }

                    if (what_to_do_next === "结束请求") {
                        this.processingEnd(what_to_do_next);
                        throw "processing is end."; //抛出错误可以直接终止生成器
                    }
                }
            }

            this.processingEnd("正常结束");
        },

        processingEnd(processing_result) {
            setTimeout(() => {
                store.commit("batchLoading", false);
                this.callback(processing_result);
            }, 1500);
        }
    }
};
</script>
<style lang="scss">
.batch-api {
    color: #137eff;
    background-color: rgba($color: #ffffff, $alpha: 0.8);
    position: fixed;
    z-index: 30000;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;

    display: flex;
    align-items: center;
    justify-content: center;
    .container {
        > div {
            margin-top: 20px;
        }
        font-size: 35px;

        text-align: center;
        .status-icon {
            font-size: 60px;
        }
    }
}
</style>